module.exports = __webpack_public_path__ + "static/media/29ADMSPC12.77619676.jpg";